import * as t from './actionTypes';

const initialState = { isLoading: false, theme: {} };

const themeReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.THEME_LOAD_SUCCESS:
            const theme = action.theme;

            return Object.assign({}, state, { theme: theme });

        default:
            return state;
    }
};

export default themeReducer;
